import { AppBasicTable } from '@components'
import { BI3DTableData, BIAggregationPrice, BIFormData, BIHeaders, BIIs3DTable, BIIsLoadingTable } from '../@signals'
import { acrissProvidersHeaders, officeHeader } from './headers'
import React from 'react'
import { officeColumn, pricesColumn } from './columns'
import { Skeleton, useTheme } from '@mui/material'
import { isLoadingCommonFilters } from '../../../../../@signals'
import { postExcel } from '@ui-seeker/utils'
import { BACKEND_APIS } from '../../../../../@constants'

export default function BI3DTable() {

    const { palette } = useTheme()

    if(!BIHeaders.value?.length || !BIIs3DTable.value) return null
    if (BIIsLoadingTable.value || isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={500}/>


    return <AppBasicTable
        data={BI3DTableData.value?.[BIAggregationPrice.value]}
        onDownload={() => postExcel(`${BACKEND_APIS.DASHBOARD}/excel`, BIFormData.value)}
        title=""
        columns={[
            officeColumn(),
            ...BIHeaders.value?.map(((acriss, idx) => pricesColumn(acriss, palette, idx)))
        ]}
        headers={[[officeHeader(), ...BIHeaders.value.map(element => acrissProvidersHeaders(element))]]}
    />

}